import { Col, ConfigProvider, message, Pagination, Row, Timeline } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import zhCN from 'antd/lib/locale/zh_CN'
import { sendHttpPostRequest } from '@/api/http-request'
import SearchInput from '../components/SearchInput/SearchInput'
import * as constants from '../../constants/constants'
import css from './college-oam.module.less'

function CollegeLoginRecords() {
  const query = useRef('')
  const page = useRef(1)
  const pageSize = useRef(20)
  const [total, setTotal] = useState(0)
  const [recordList, setRecordList] = useState([] as any)

  const onPageChange = (np: number) => {
    page.current = np
    setRecordList([])
    getCollegeLoginRecords()
  }

  useEffect(() => {
    getCollegeLoginRecords()
  }, [])

  const getCollegeLoginRecords = () => {
    sendHttpPostRequest(
      'college/api/get_college_login_log',
      { page: page.current, query: query.current },
      (res: any) => {
        if (res.code == 0) {
          setRecordList([...res.data.list])
          setTotal(res.data.page_info.total_count)
        } else {
          message.error(res.msg)
        }
      }
    )
  }

  return (
    <div className={css.loginRecordsWrapper}>
      <div className={css.loginRecordsHeader}>
        <h3 className={css.loginRecordsTitle}>登录动态</h3>
        <SearchInput
          onSearch={() => {
            page.current = 1
            setRecordList([])
            getCollegeLoginRecords()
          }}
          width={220}
          placeholder="请输入姓名"
          onChange={(e: any) => {
            query.current = e.target.value
          }}
        />
      </div>

      <div className={css.loginRecordsTimeline}>
        <Timeline mode="left">
          {recordList?.map((item: any) => (
            <Timeline.Item
              dot={<div className={css.loginRecordsDot} />}
              key={item.id}
              label={item.log_time}
            >
              <Row align="middle" gutter={8}>
                <Col>
                  <img
                    className={css.loginRecordsAvatar}
                    src={constants.BACKEND_API_URL + item.avatar}
                    alt=""
                  />
                </Col>
                <Col>{item.real_name || item.user_name}</Col>
                <Col style={{ color: '#6b7280' }}>{item.log_type}</Col>
              </Row>
            </Timeline.Item>
          ))}
        </Timeline>
      </div>

      <ConfigProvider locale={zhCN}>
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Pagination
            current={page.current}
            total={total}
            pageSize={pageSize.current}
            hideOnSinglePage
            onChange={onPageChange}
          />
        </div>
      </ConfigProvider>
    </div>
  )
}

export default CollegeLoginRecords
